// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

import { AddonData, AllowedAddon, ContentSneakPeakData, ImageData } from '../../../../contexts'
import { ImageProps } from '../../../../dsl/atoms/Image'
import { toImageProps } from '../../../shared/support'

import { ArticleCardProps } from './ArticleCard.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const translateContentToArticleCard = (content: ContentSneakPeakData): ArticleCardProps => {
  let categories: AnyObject[] | undefined
  let cover: ImageProps | undefined
  let lead: string = ''

  const coverAddon: AddonData | undefined = content.properties[AllowedAddon.Cover]
  if (typeof coverAddon === 'object' && coverAddon !== null) {
    cover = toImageProps(coverAddon.image as ImageData)
  }

  const leadAddon: AddonData | undefined = content.properties[AllowedAddon.Lead]

  if (typeof leadAddon !== 'undefined') {
    lead = Object.values(leadAddon)[0]
  }

  const categoriesAddon: AddonData | undefined = content.properties[AllowedAddon.Categories]
  if (Array.isArray(categoriesAddon) && categoriesAddon.length > 0) {
    categories = categoriesAddon
  }

  return {
    publicationDate: content.publicationDate,
    categories: (typeof categories !== 'undefined' && typeof categories !== 'number') ? categories : undefined,
    content: lead,
    cover,
    heading: content.title,
    link: content.urlPath
  }
}

// /**
//  * @author Kuba Fogel <kuba.fogel@movecloser.pl>
//  */
// export const translateContentToArticleCard = (content: ContentSneakPeakData): ArticleCardProps => {
//   console.log({ content })
//
//   let categories: AnyObject[] | undefined
//   // let cover: ImageProps | undefined
//   let lead: string = ''
//
//   // const coverAddon: AddonData | undefined = content.properties[AllowedAddon.Cover]
//   // if (typeof coverAddon === 'object' && coverAddon !== null) {
//   //   cover = toImageProps(coverAddon.image as ImageData)
//   // }
//
//   const leadAddon: AddonData | undefined = content.properties[AllowedAddon.Lead]
//
//   if (typeof leadAddon !== 'undefined') {
//     lead = Object.values(leadAddon)[0]
//   }
//
//   const categoriesAddon: AddonData | undefined = content.properties[AllowedAddon.Categories]
//   if (Array.isArray(categoriesAddon) && categoriesAddon.length > 0) {
//     categories = categoriesAddon
//   }
//
//   return {
//     publicationDate: content.publicationDate,
//     categories: (typeof categories !== 'undefined' && typeof categories !== 'number') ? categories : undefined,
//     content: content.properties[AllowedAddon.Lead],
//     cover: content.cover,
//     heading: content.title,
//     link: content.urlPath
//   }
// }
